import React, { useCallback, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import List from 'src/components/grid.component';
import { AmountColumnHandler, CreatedDateColumnHandler, FeeColumnHandler, StatusColumnHandler } from './service';

const CardViewTransactionGrid = (props) => {
  const gridRef = React.createRef();
  const cardDivRef = React.useRef(null);
  let { id } = useParams();
  const shouldLog = useRef(true);
  const apiTransactionUrl = process.env.REACT_APP_GRID_API + `api/KycService/CardsTransaction/${id}/${props?.cardId}`;

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
    }

  }, [props?.showTransactions]);

  const dateColumnHandler = (props) => { return (<CreatedDateColumnHandler data={props} />) }
  const statusColumnHandler = (props) => { return (<StatusColumnHandler data={props} />) }
  const amountColumnHandler = (props) => { return (<AmountColumnHandler data={props} />) }
  const feeColumnHandler = (props) => { return (<FeeColumnHandler data={props} />) }
  const customcells = {
    "dateTime": dateColumnHandler,
    "state": statusColumnHandler,
    "amount": amountColumnHandler,
    "fee":feeColumnHandler
  };

  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [])

  return (
    <>
      <div ref={cardDivRef}></div>
      <p className='text-titleColor font-semibold text-2xl  mb-2 mt-4 '>Transactions</p>
      <List
        showExcelExport={true}
        url={apiTransactionUrl}
        ref={gridRef}
        pSize={10}
        className="custom-grid grid-alignment"
        pKey={"Transactions"}
        sortable={true}
        screenName={'Customer_Card_Transactions'}
        renderCustomCell={renderCustomCell}
        showDisplayColumns={false}
      />

    </>
  );
};
export default CardViewTransactionGrid
